export enum RoutesPath {
  CONFIRMATION_PAGE = 'confirmation',
  ERROR_PAGE = 'erreur',
  ONBOARDING_PAGE = '',
  PERSONAL_PAGE = 'informations-personnelles',
  SUMMARY_PAGE = 'recapitulatif',
  TERMINATION_PAGE = 'informations-resiliation',
}
